export default __webpack_public_path__ + "static/media/uz.562cdaf4.svg";